<template>
  <div class="flex flex-col items-center py-4">
    <div class="pb-4">
      <RadioField
        v-for="(pauseInterval, index) in pauseIntervals"
        :key="index"
        v-model="selectedIntervalValue"
        :value="pauseInterval.intervalValue"
        class="pb-4"
      >
        {{ pauseInterval.intervalValue }}
        <CommonLabel
          :path="`BWF/shop/account/subscriptions/contract/${getIntervalUnit(pauseInterval)}`"
        />
      </RadioField>
    </div>
    <div class="font-bold">
      <CommonLabel path="BWF/shop/account/subscriptions/contract/nextDeliveryLabel" />:
      <FormattedDate
        v-if="activeIntervalOption?.nextExecutionDate"
        :date="activeIntervalOption?.nextExecutionDate"
        pattern="DD.MM.YY"
      />
    </div>
  </div>
</template>

<script setup>
import RadioField from "~/templates/elements/form/RadioField.vue";
import FormattedDate from "~/templates/elements/FormattedDate.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";

const { getLabels } = useCommonLabels();

const props = defineProps(["pauseIntervals", "modelValue"]);

const selectedIntervalValue = defineModel("modelValue");

const activeIntervalOption = computed(() => {
  return props.pauseIntervals?.find(
    (interval) => interval.intervalValue === selectedIntervalValue.value,
  );
});

const getIntervalUnit = (interval) => {
  /*
  Shopware intervalUnits are always in plural (days, weeks, months and years)
  to map the CommonLabel for single versions we have to slice the last letter ('s')
  to get day, week, month and year
  */

  const unit = interval.intervalUnit;
  const value = interval.intervalValue;

  if (value === 1) {
    return unit.slice(0, -1); //months -> month
  } else {
    return unit; //months
  }
};
</script>
